<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qGZbfo/tc-custom/9781618681072.jpg?1737689210305" alt="This image is the cover for the book Blood Soaked & Contagious"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blood Soaked & Contagious
      </h1>
      <p class="bookDescription body article font2">
        <b>A zombie killer-for-hire faces off against a dangerous undead overlord in this post-apocalyptic science fiction horror series debut.</b><br/><br/>I am not going to complain to you about my life.<br/><br/>We’ve got zombies. They are not the brainless, rotting creatures we’d been led to expect. Unfortunately for us, they’re just as smart as they were before they died, very fast, much stronger than you or me, and possess no internal editor at all.<br/><br/>Claws. Did I mention claws?<br/><br/>I kill them for a living, but it’s as much a vocation as a freelance career choice. It helps me, helps my neighborhood, and the people I consider to be my family of choice. What’s more? I’m really good at it.<br/><br/>My life had a nice rhythm, and I'd almost gotten used to it, but the military bungled an attempt to wipe out an organized bunch of undead near a major commuting route into D.C. The formerly-human survivors relocated. Now they’re less than an hour’s stroll away from where I live.<br/><br/>The new Zombie Overlord is smarter, crazier, and much more well-equipped than anyone we’d dealt with in the past. We have something he wants, badly. I know he’s going to come and get it and try and wipe us out in the process . . . men, women, and even the children. I’d seen it done before elsewhere for lesser reasons.<br/><br/>This is my home. These are my people, my family. This is personal.<br/><br/><b>Praise for <i>Blood Soaked and Contagious</i></b><br/><br/><b>“I give it an “EW!” factor of +10!” —Diana Gabaldon, #1 <i>New York Times</i>–bestselling author of the Outlander Series</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Crawford
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Permuted Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6eb62984